import type { ReactNode } from 'react';
import React from 'react';
import List from 'components/List';
import Media from 'components/Media';
import './nestedPage.css';

interface NestedPageProps {
  children: ReactNode;
  backButtonText?: string;
  backButtonHref?: string;
}

const NestedPage = ({ children, backButtonText = 'Back', backButtonHref }: NestedPageProps) => (
  <Media query="(min-width: 768px)">
    {(isDesktop) => (
      <div className="nestedPage">
        {backButtonText && (
          <List.Root
            className="nestedPage__linkBack"
            variant={isDesktop ? List.Variant.Card : List.Variant.FullWidth}
          >
            <List.LinkBack href={backButtonHref}>{backButtonText}</List.LinkBack>
          </List.Root>
        )}
        {children}
      </div>
    )}
  </Media>
);

export default NestedPage;
